export const SUBSCRIPTION_TERMS = "Local taxes apply. If eligible for a free trial, subscribers will be charged after the free trial period ends, otherwise users will be charged upon checkout. By purchasing subscription you agree to our Terms & Conditions. Plan automatically renews until cancelled. For how and when to cancel see the billing platform’s terms.";
/** Presentation offers from Figma 2115:49706 and 220:8590. Checkout remains a no-op. */
export function subscriptionOffers(competition = "ligue-1") {
    const ligue3 = competition === "ligue-3";
    return [
        {
            title: "Annual Pass",
            artwork: ligue3 ? "ligue-3-annual" : undefined,
            subtitle: "Best value for the full season",
            price: "€79.99",
            priceSuffix: "/Season",
            popular: true,
            featureFontSize: 26,
            features: [
                "8 of 9 matches are shown live",
                "All 9 matches available on\ndemand",
                "Exclusive weekly shows\n(L1 Show & 90')",
                "100+ originals, documentaries\nand highlights",
                "Full-season access",
            ],
        },
        {
            title: "Monthly Pass",
            artwork: ligue3 ? "ligue-3-compact" : undefined,
            subtitle: "Full access, no commitment",
            price: "€9.99",
            priceSuffix: "/Month",
            featureFontSize: 22,
            features: [
                "8 of 9 matches live each round",
                "All 9 matches available on demand",
                "Exclusive shows and 100+ original\nprogrammes",
                "Cancel anytime",
            ],
        },
        {
            title: "Day Pass",
            artwork: ligue3 ? "ligue-3-compact" : undefined,
            subtitle: "Unlimited access for 24 hours",
            price: "€3.99",
            priceSuffix: ligue3 ? "/24 Hours" : "/24Hours",
            featureFontSize: 22,
            features: [
                "One-off payment for 24 hours of access\nincluding Live matches.",
                "Exclusive shows, documentaries and\nhighlights",
                "Access to the full Ligue 1+ content\nlibrary",
            ],
        },
    ];
}
//# sourceMappingURL=subscriptionOffers.js.map